<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <!-- {{canteen_approval_hierarchy_list}} -->
        <v-data-table :headers="headers" :items="canteen_approval_hierarchy_list" class="elevation-1 mytable" dense
            :search="search">
            <template v-slot:top>
                <v-toolbar dense flat class="toolbar">
                    <v-toolbar-title>Canteen Approval Hierarchy</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                    <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details>
                    </v-text-field>
                    <span style="width: 20px;"></span>
                    <v-dialog v-model="dialog" max-width="500px">
                        <template v-slot:activator="{ on }">
                            <v-btn color="mb-2 button" small v-on="on">Add Canteen Approval Hierarchy</v-btn>
                        </template>
                        <v-card>
                            <v-form v-model="valid">
                                <v-card-title>
                                    <span class="headline">{{ formTitle }}</span>
                                </v-card-title>
                                <v-card-text>
                                    <v-container>
                                        <v-row>
                                            <v-col cols="12" sm="12" md="12">
                                                <v-text-field v-model="editedItem.level" persistent-hint
                                                    :hint="editedIndex==-1?'For example :: 1,2,3':'For example :: 1,2,3'"
                                                    label="Enter Level No" :rules="[v => !!v || 'required']"
                                                    type="number" rounded outlined dense>
                                                </v-text-field>
                                            </v-col>
                                            <v-col cols="12">
                                                <v-autocomplete rounded outlined dense
                                                    v-model="editedItem.canteenapporvalauthorityId"
                                                    :items="canteen_approval_authority_list"
                                                    :rules="[v => !!v || 'required']" item-text="authority"
                                                    item-value="id" label="Canteen Approval Authority"
                                                    :filled="editedIndex==-1?false:true" return-object
                                                    single-line></v-autocomplete>
                                            </v-col>

                                            <v-col cols="10">
                                                <v-checkbox v-model="editedItem.is_last_approval" color="success"
                                                    label="Is Last?"></v-checkbox>
                                            </v-col>

                                            <v-col cols="10">
                                                <v-checkbox v-model="editedItem.isActive" color="success"
                                                    label="Is Active?"></v-checkbox>
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="mb-2 button" text @click="close">Cancel</v-btn>
                                    <v-btn color="mb-2 button" @click="save" :disabled="!valid">Save</v-btn>
                                </v-card-actions>
                            </v-form>
                        </v-card>
                    </v-dialog>
                </v-toolbar>
                <br>
            </template>

            <template v-slot:item.isactive="{ item }">
                <span v-if="item.isactive">
                    <v-icon small class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
                </span>
                <span v-else>
                    <v-icon small class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                </span>
            </template>

            <template v-slot:item.is_last_approval="{ item }">
                <span v-if="item.is_last_approval">
                    <v-icon small class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
                </span>
                <span v-else>
                    <v-icon small class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                </span>
            </template>

            <template v-slot:item.action="{ item }">
                <div>
                    <v-avatar style="" size="25" class="edit-avatar">
                        <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
                    </v-avatar>
                </div>
            </template>
        </v-data-table>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </div>
</template>

<script>
    import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
    components: {
        Breadcrumbs,
    },
        data: () => ({
            valid: false,
            overlay: false,
            // extraBreadcrumbItems: [
            //     { text: "Approval Hierachy Master", disabled: true, href: "" },

            // ],
            // breadcrumbClass: "breadcrumb-style1",
            errorMsg: {
                castId: false,
            },
            snackbar_msg: "",
            color: "",
            snackbar: false,
            search: "",
            dialog: false,
            headers: [
                {
                    text: "Sr No",
                    align: "left",
                    sortable: true,
                    value: "srno",
                },
                {
                    text: "Level No",
                    align: "left",
                    sortable: true,
                    value: "level",
                },
                {
                    text: "Canteen Approval Authority",
                    align: "left",
                    sortable: true,
                    value: "authority",
                },
                {
                    text: "Is Last Approved?",
                    align: "left",
                    sortable: true,
                    value: "is_last_approval",
                },
                {
                    text: "Is Active?",
                    align: "left",
                    sortable: true,
                    value: "isactive",
                },
                { text: "Actions", value: "action", sortable: false },
            ],
            canteen_approval_hierarchy_list: [],
            canteen_approval_authority_list: [],
            editedIndex: -1,
            editedItem: {
                canteenApprovalHierarchyId: "",
                level: "",
                isActive: true,
                is_last_approval: false,
                canteenapporvalauthorityId: "",
            },
            defaultItem: {
                canteenApprovalHierarchyId: "",
                level: "",
                isActive: true,
                is_last_approval: false,
                canteenapporvalauthorityId: "",
            },
        }),

        computed: {
            formTitle() {
                return this.editedIndex === -1 ? "New Canteen Approval Hierarchy" : "Edit Canteen Approval Hierarchy";
            },
        },

        watch: {
            dialog(val) {
                val || this.close();
            },
            overlay(val) {
                val = () => {
                    this.overlay = false;
                };
            },
        },
        mounted() {
            this.onLoad();
        },
        methods: {
            initializeErrorMsgFalse() {
                this.errorMsg.castId = false;
            },

            onLoad() {
                this.overlay = true;
                axios
                    .post("/Canteen/getCanteenApprovalHierarchyList")
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.overlay = false;
                            this.canteen_approval_hierarchy_list = res.data.canteen_approval_hierarchy_list;
                            this.canteen_approval_authority_list = res.data.canteen_approval_authority_list;
                        } else {
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                        window.console.log("Errro------>" + error);
                    })
                    .finally(() => {
                        var overlay = false;
                    });
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },

            editItem(item) {
                this.editedIndex = this.canteen_approval_hierarchy_list.indexOf(item);
                this.dialog = true;
                this.editedItem.level = item.level.toString();
                this.editedItem.isActive = item.isactive;
                this.editedItem.canteenApprovalHierarchyId = item.id;
                this.editedItem.is_last_approval = item.is_last_approval;
                this.editedItem.canteenapporvalauthorityId = item.authority_id;
            },

            close() {
                this.dialog = false;
                setTimeout(() => {
                    this.editedItem = Object.assign({}, this.defaultItem);
                    this.editedIndex = -1;
                }, 300);
            },

            save() {
                if (this.editedIndex > -1) {
                    if (this.isValidated()) {
                        axios
                            .post("/Canteen/editCanteenApprovalHierarchy", this.editedItem)
                            .then((res) => {
                                if (res.data.status.code == "SUCCESS") {
                                    this.showSnackbar("#4caf50", "Canteen Approval Hierarchy Updated Successfully..."); // show snackbar on success
                                    this.onLoad();
                                } else if (res.data.status.code == "NA") {
                                    this.showSnackbar("#b71c1c", "Canteen Approval Hierarchy Already Present!!!"); // show snackbar on error
                                } else if (res.data.status.code == "ILA") {
                                    this.showSnackbar("#b71c1c", res.data.status.msg); // show snackbar on error
                                }
                            })
                            .catch((error) => {
                                window.console.log(error);
                            });

                        this.close();
                    }
                } else {
                    axios
                        .post("/Canteen/saveCanteenApprovalHierarchy", this.editedItem)
                        .then((res) => {
                            if (res.data.status.code == "SUCCESS") {
                                this.canteen_approval_hierarchy_list.push(this.editedItem);
                                this.showSnackbar("#4caf50", "Canteen Approval Hierarchy Added Successfully..."); // show snackbar on success
                                this.onLoad();
                            } else if (res.data.status.code == "NA") {
                                this.showSnackbar("#b71c1c", "Canteen Approval Hierarchy Already Present!!!"); // show snackbar on error
                            }
                        })
                        .catch((error) => {
                            window.console.log(error);
                        });

                    this.close();
                }
            }, // end of save()

            isValidated() {
                if (this.editedItem.canteenApprovalHierarchyId) {
                    return true;
                } else {
                    if (!this.editedItem.id) {
                        this.errorMsg.canteenApprovalHierarchyId = true;
                    }

                    return false;
                }
            }, // .....end of isValidated()
        },
    };
</script>
<style scoped>
    .v-text-field {
        padding-top: 0px;
        margin-top: 0px;
    }
    .v-icon-size {
        font-size: 20px;
    }
    .edit-avatar {
        transition: 0.3s;
        border: 1px solid #b0bec5;
    }
    .edit-avatar:hover {
        background-color: #b0bec5;
    }
    .edit-v-icon {
        padding-left: 6px;
        font-size: 15px;
    }
    .edit-v-icon:hover {
        color: white;
    }
</style>
